var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1242_16108)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6403 15.7345L15.8903 11.9845C15.8199 11.9141 15.7245 11.8746 15.625 11.8746C15.5255 11.8746 15.43 11.9141 15.3597 11.9845C15.2893 12.0548 15.2498 12.1503 15.2498 12.2498C15.2498 12.3493 15.2893 12.4447 15.3597 12.5151L18.8448 15.9998L15.3597 19.4845C15.2893 19.5548 15.2498 19.6503 15.2498 19.7498C15.2498 19.8493 15.2893 19.9447 15.3597 20.0151C15.43 20.0855 15.5255 20.125 15.625 20.125C15.7245 20.125 15.8199 20.0855 15.8903 20.0151L19.6403 16.2651C19.6751 16.2303 19.7028 16.1889 19.7217 16.1434C19.7405 16.0979 19.7503 16.0491 19.7503 15.9998C19.7503 15.9505 19.7405 15.9017 19.7217 15.8562C19.7028 15.8107 19.6751 15.7693 19.6403 15.7345ZM23.3903 16.2651L19.6403 20.0151C19.5699 20.0855 19.4745 20.125 19.375 20.125C19.2755 20.125 19.18 20.0855 19.1097 20.0151C19.0393 19.9447 18.9998 19.8493 18.9998 19.7498C18.9998 19.6503 19.0393 19.5548 19.1097 19.4845L22.5948 15.9998L19.1097 12.5151C19.0393 12.4447 18.9998 12.3493 18.9998 12.2498C18.9998 12.1503 19.0393 12.0548 19.1097 11.9845C19.18 11.9141 19.2755 11.8746 19.375 11.8746C19.4745 11.8746 19.5699 11.9141 19.6403 11.9845L23.3903 15.7345C23.4251 15.7693 23.4528 15.8107 23.4717 15.8562C23.4905 15.9017 23.5003 15.9505 23.5003 15.9998C23.5003 16.0491 23.4905 16.0979 23.4717 16.1434C23.4528 16.1889 23.4251 16.2303 23.3903 16.2651Z",
    fill: "#153E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1242_16108",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1242_16108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1242_16108",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDrawer);
export default __webpack_public_path__ + "static/media/open-drawer.0afa6ca17245b850c29cad62a1d8c42b.svg";
export { ForwardRef as ReactComponent };